import axios from 'axios';
import { useState, createContext, useEffect } from 'react';

const BUILD_URL = process.env.REACT_APP_BACKEND_URL;
// const ACCESS_TOKEN = process.env.REACT_APP_ACCEESS_TOKEN;

// const authAxios = axios.create({
//   baseUrl: BUILD_URL,
//   headers: {
//     // Authorization: `Bearer ${ACCESS_TOKEN}`,
//     Token: `${ACCESS_TOKEN}`,
//     Type: 'outward',
//     Resource: 'orders/order-tracker',
//     'Content-Type': 'application/json',
//   },
// });

export const OrderDetailsContext = createContext();

export function OrderDetailsProvider({ children }) {
  const [orderDetail, setOrderDetail] = useState([]);
  const [requestError, setRequestError] = useState();
  const [loading, setLoading] = useState('yes');
  const [isError, setIsError] = useState('no');
  const [slottedOrder, setSlottedOrder] = useState('no');
  const [orderType, setOrderType] = useState('');
  var currentLocation = window.location.pathname;
  const orderId = currentLocation.replace('/order/', '');
  const currentDate = new Date().valueOf();

  useEffect(() => {
    async function getOrderDetails() {
      try {
        // fetch order details
        // const result = await authAxios.post(`${BUILD_URL}/orders/${orderId}`);
        const result = axios
          .get(`${BUILD_URL}/track_orders?orderid=${orderId}`)
          .then((res) => {
            setOrderDetail(res?.data);
            setLoading('no');
          });
      } catch (e) {
        // set req err msg
        setRequestError(e.message);
        console.log(e.message);
        setIsError('yes');
        setLoading('no');
      }
    }

    getOrderDetails();
  }, [orderId]);

  useEffect(() => {
    if (orderDetail?.detailMessage === undefined) {
      setIsError('no');
    } else if (orderDetail?.detailMessage !== null) {
      setRequestError(orderDetail?.detailMessage);
      setIsError('yes');
    } else {
      setIsError('no');
    }
  }, [orderDetail]);

  // checking order type for navigation
  useEffect(() => {
    if (
      orderDetail?.response?.timeSlotStart !== null &&
      orderDetail?.response?.timeSlotEnd !== null
    ) {
      if (orderDetail?.response?.timeSlotStart <= currentDate) {
        setSlottedOrder('no');
        setOrderType('slotted');
      } else {
        setSlottedOrder('yes');
        setOrderType('slotted');
      }
    } else if (
      orderDetail?.response?.orderState === 'Completed' &&
      orderDetail?.response?.timeSlotStart !== null &&
      orderDetail?.response?.timeSlotEnd !== null
    ) {
      setSlottedOrder('yes');
      setOrderType('slotted');
    } else {
      setSlottedOrder('no');
      setOrderType('express');
    }
  }, [orderDetail, currentDate]);

  return (
    <OrderDetailsContext.Provider
      value={{
        orderDetail: orderDetail,
        requestError: requestError,
        isError: isError,
        loading: loading,
        slottedOrder: slottedOrder,
        orderType: orderType,
      }}
    >
      {children}
    </OrderDetailsContext.Provider>
  );
}
